import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#FAFAF7'
  }} data-id="element-162">
      <motion.div className="max-w-3xl mx-auto px-4" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7
    }} data-id="element-163">
        <p className="text-lg md:text-xl leading-relaxed mb-6" style={{
        color: '#4A4A4A'
      }} data-id="element-164">
          Son las{' '}
          <strong style={{
          color: '#1A1A1A'
        }} data-id="element-165">
            7:00 AM
          </strong>
          . Estás frente al espejo y ese pantalón que tanto te gusta simplemente
          no cierra. No es que hayas subido de peso el fin de semana; es que tu
          cuerpo está enviando una señal de auxilio en forma de inflamación.
        </p>

        <p className="text-lg md:text-xl leading-relaxed mb-6" style={{
        color: '#4A4A4A'
      }} data-id="element-166">
          Esa sensación de estar <em data-id="element-167">"embarazada"</em> sin estarlo, el cansancio
          mental y la pesadez después de comer{' '}
          <strong style={{
          color: '#1A1A1A'
        }} data-id="element-168">
            no son normales
          </strong>
          .
        </p>

        <p className="text-xl md:text-2xl font-medium leading-relaxed" style={{
        color: '#1A1A1A',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-169">
          Tu cuerpo no necesita otra dieta restrictiva de hambre; necesita un
          interruptor que apague el incendio digestivo{' '}
          <span style={{
          color: '#C9A96E'
        }} data-id="element-170">
            hoy mismo
          </span>
          .
        </p>

        <div className="mt-8 flex justify-center" data-id="element-171">
          <div className="w-24 h-1 rounded-full" style={{
          backgroundColor: '#C9A96E'
        }} data-id="element-172" />
        </div>
      </motion.div>
    </section>;
}